/* eslint-disable max-len */
/* eslint-disable react/prop-types */
/* eslint-disable max-len */
import React, { useState, useEffect } from 'react';
import {
  Form,
  Input,
  Button,
  Row,
  Col,
  Spin,
  Tabs,
  Modal,
  DatePicker,
} from 'antd';
import {
  CheckCircleOutlined,
} from '@ant-design/icons';
import Select from 'components/Select';
import { onError, onSuccess } from 'utils/handlers';
import {
  getEstadosGlobales,
} from 'api/catalogos';
import Table from 'components/Table';
import { ESTATUS_ACTIVO, ESTATUS_AUTORIZADO, ESTATUS_INACTIVO } from 'utils/constants';
import ModalConfirmation from 'components/ModalConfirmation';
import ModalDelete from 'components/ModalDelete';
import FormSubmitControls from 'components/FormSubmitControls';
import {
  autorizarIncidenciaValidacion,
  deleteIncidenciaValidacion,
  getIncidenciaValidacion, getIncidenciasValidaciones, getIncidenciasValidacionesPag, patchIncidenciaValidacion, postIncidenciaValidacion,
} from 'api/configuraciones/clock/Incidencias/IncidenciaValidacion';
import { formatReceived, formatReceivedValues } from 'utils/formatValues';
import moment from 'moment/moment';
import { getConfiguracionIncidencias } from 'api/nominas/incidencias/configuracionIncidencias';
import { getTiposDeIncidenciasUnidades } from 'api/nominas/incidencias/tiposIncidenciasUnidades';
import { getAplicaciones } from 'api/catalogos/PeriocidadDeAplicacion';
import { getEvaluacionesAsistencia } from 'api/catalogos/TiposDeEvaluacionAsistencia';

export const validacionesConfigPermission = {
  permissionModel: 'incidenciaPeriocidad',
  catalogsModels: [],
  tabsModels: [],
};

const ValidacionesConfigReloj = ({ permission }) => {
  const [form] = Form.useForm();
  const [isAdding, setAdding] = useState(true);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [loading, setLoading] = useState(false);
  const [open, setVisible] = useState(false);
  const [visibleAlert, setVisibleAlert] = useState(false);
  const [data, setData] = useState([]);
  const [estados, setEstados] = useState([]);
  const [visibleAutorizar, setVisibleAutorizar] = useState(false);
  const [selectedData, setSelectedData] = useState({});
  const [visibleConfirmInactivo, setVisibleConfirmInactivo] = useState(false);
  const [disableFields, setDisableFields] = useState(false);
  const [pageActual, setPageActual] = useState(1);
  const [evaluacionAsistencia, setEvaluacionAsistencia] = useState([]);
  const [incidencia, setIncidencia] = useState([]);

  const formInstances = [
    form,
  ];

  const numeroDias = (fieldName) => (e) => {
    const rawValue = e.target.value;

    // Keep only digits
    const filtered = rawValue.replace(/\D/g, '');

    // Convert to number
    const num = Number(filtered);

    // Only update if it's greater than 0
    if (num > 0) {
      form.setFieldsValue({ [fieldName]: num });
    } else {
      // If it's 0 or less, maybe clear it or set empty string
      form.setFieldsValue({ [fieldName]: '' });
    }
  };

  const fetchPaginated = async (page = 1, q = null) => {
    try {
      setLoading(true);

      const cleanPage = Number(String(page).replace(/\D/g, ''));
      const _data = await getIncidenciasValidacionesPag({ page: cleanPage, ...q });

      const { results } = _data;

      setSelectedRowKeys([]);
      setPageActual(cleanPage);
      setData({ ..._data, results: [...results] });
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  const fetchData = async () => {
    setLoading(true);
    const _data = await getIncidenciasValidaciones();
    setData(formatReceived(_data));
    setLoading(false);
  };
  useEffect(() => {
    let mounted = true;
    const fetchAll = async () => {
      setLoading(true);
      const [
        _incidencias,
        _tipoEvaluacionAsistencia,
        _data,
        _estados,
      ] = await Promise.all([
        getConfiguracionIncidencias({ estados_globales: ESTATUS_AUTORIZADO }),
        getEvaluacionesAsistencia({ estados_globales: ESTATUS_AUTORIZADO }),
        getIncidenciasValidaciones(),
        getEstadosGlobales(),
      ]);
      if (mounted) {
        setIncidencia(_incidencias);
        setEvaluacionAsistencia(_tipoEvaluacionAsistencia);
        setData(_data);
        setEstados(_estados);
        setLoading(false);
      }
    };
    fetchAll();
    return () => { mounted = false; };
  }, []);

  const onCancel = () => {
    setVisible(false);
    setVisibleAutorizar(false);
    setDisableFields(false);
    setSelectedRowKeys([]);
    setSelectedData({});
  };
  const onClickEdit = async (responseData = null) => {
    setLoading(true);
    setAdding(false);
    const [key] = selectedRowKeys;
    const match = responseData || data?.results?.find((item) => item.id === key);
    const _validacionesConfigReloj = await getIncidenciaValidacion(match.id);

    setTimeout(() => {
      if (_validacionesConfigReloj) {
        const formValues = {
          concepto_incidencia: _validacionesConfigReloj.concepto_incidencia?.id,
          concepto_evaluacion: _validacionesConfigReloj.concepto_evaluacion?.id,
          // Asigna el ID del estado global
          // Convierte la fecha de vigencia final a objeto moment si existe, si no null
          vigencia_final: _validacionesConfigReloj.vigencia_final
            ? moment(_validacionesConfigReloj.vigencia_final)
            : null,
          fecha_inicial: _validacionesConfigReloj.fecha_inicial
            ? moment(_validacionesConfigReloj.fecha_inicial)
            : null,
          fecha_final: _validacionesConfigReloj.fecha_final
            ? moment(_validacionesConfigReloj.fecha_final)
            : null,

          // Asigna el ID del estado global
          estados_globales: _validacionesConfigReloj.estados_globales?.id, //  aquí sí es un ID
        };
        form.resetFields();
        setTimeout(() => {
          form.setFieldsValue(formatReceived(formValues));
          setDisableFields(_validacionesConfigReloj?.estados_globales?.id !== ESTATUS_ACTIVO);
          setVisible(true);
        });
      }
    });
    setLoading(false);
  };
  const onClickAdd = () => {
    setAdding(true);
    form.resetFields();
    onCancel();
    setVisible(true);
  };

  const onClickDelete = () => {
    setVisibleAlert(true);
  };

  const onFinish = async (_continue = false) => {
    try {
      setLoading(true);
      await form.validateFields();

      const values = form.getFieldsValue();
      const [key] = selectedRowKeys;

      if (values.vigencia_final?.format) {
        values.vigencia_final = values.vigencia_final.format('YYYY-MM-DD');
      }
      if (values.fecha_inicial?.format) {
        values.fecha_inicial = values.fecha_inicial.format('YYYY-MM-DD');
      }
      if (values.fecha_final?.format) {
        values.fecha_final = values.fecha_final.format('YYYY-MM-DD');
      }
      const saved = await (key ? patchIncidenciaValidacion(key, values) : postIncidenciaValidacion(values));
      if (saved) {
        if (_continue) {
          await fetchData();
          setSelectedRowKeys([saved.id]);
          onClickEdit(saved);
        } else {
          onCancel();
          await fetchData();
        }
      }
      setLoading(false);
    } catch (err) {
      onError(
        err,
        setLoading,
        formInstances,
      );
    }
  };

  const deleteItem = async () => {
    try {
      setLoading(true);
      if (selectedRowKeys.length) {
        const [key] = selectedRowKeys;
        const deleted = await deleteIncidenciaValidacion(key);
        if (deleted) {
          setVisibleAlert(false);
          onCancel();
          await fetchData();
        }
      }
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  const handleOnRowClick = (record) => {
    setSelectedRowKeys([record.id]);
    setSelectedData({ ...record });

    const dataForForm = {
      ...record,
      vigencia_final: record.vigencia_final
        ? moment(record.vigencia_final)
        : null,
      fecha_inicial: record.fecha_inicial
        ? moment(record.fecha_inicial)
        : null,
      fecha_final: record.fecha_final
        ? moment(record.fecha_final)
        : null,
    };

    form.setFieldsValue(dataForForm);
  };
  const rowSelection = {
    selectedRowKeys,
    type: 'radio',
  };
  const onConfirmAutorizar = async () => {
    try {
      setLoading(true);
      const [key] = selectedRowKeys;
      if (!key) {
        setLoading(false);
        onCancel();
        onSuccess({}, 'No se puede autorizar un Incidencia Validacion ya autorizado');
        return;
      }
      const saved = await autorizarIncidenciaValidacion(key);
      if (saved) {
        const _data = await getIncidenciasValidaciones();
        setData(formatReceived(_data));
        onCancel();
      }
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  const columns = [
    {
      titleText: 'Concepto de Incidencia',
      dataIndex: 'concepto_incidencia',
      key: 'concepto_incidencia',
      width: 200,
      render: (_, record) => `${record?.concepto_incidencia?.clave}  ${record?.concepto_incidencia?.concepto}` || 'n/a',
    },
    {
      titleText: 'Concepto de Evaluación',
      dataIndex: 'concepto_evaluacion',
      key: 'concepto_evaluacion',
      width: 200,
      render: (_, record) => record?.concepto_evaluacion?.nombre || 'n/a',
    },
    {
      titleText: 'Vigencia Final',
      dataIndex: 'vigencia_final',
      key: 'vigencia_final',
      width: 150,
    },
    {
      titleText: 'Estatus',
      dataIndex: 'estados_globales',
      key: 'estados_globales',
      width: 180,
      render: (_, record) => record?.estados_globales?.descripcion || 'n/a',
    },
  ];

  const requiredRule = {
    required: true,
    message: 'El campo es requerido',
  };

  const rules = {
    required: [requiredRule],
  };

  return (
    <Row align="center" justify="center" className="container">
      <Col span={24}>
        <Spin tip="Cargando..." spinning={loading}>
          <Table
            cols={columns}
            data={data?.results || []}
            pagination={false}
            paginationCallback={fetchPaginated}
            count={data?.count || 0}
            rowSelection={rowSelection}
            handleOnRowClick={handleOnRowClick}
            controls={{
              onClickAdd,
              onClickEdit: () => onClickEdit(),
              onClickDelete,
            }}
            customActions={[
              {
                onClick: () => setVisibleAutorizar(true),
                permission: { model: 'incidenciavalidacion', action: 'autorizar' },
                icon: <CheckCircleOutlined />,
                text: 'Autorizar',
                disabledBySelection: true,
                disabled: selectedData?.estados_globales?.id !== ESTATUS_ACTIVO,
                className: 'success',
              },
            ]}
            disableDelete={selectedData?.estados_globales?.id !== ESTATUS_ACTIVO}
            permission={permission}
            allowExportParam={false}
            allowSearch={false}
          />
          <Modal
            open={open}
            closable={false}
            maskClosable={!loading}
            keyboard={!loading}
            footer={null}
            title={(
              <FormSubmitControls
                label={`${selectedRowKeys.length ? 'Editar' : 'Agregar'} Incidencia Validacion`}
                onFinish={onFinish}
                onCancel={onCancel}
                loading={loading}
              />
            )}
            onCancel={onCancel}
            forceRender
          >
            <Form
              layout="vertical"
              form={form}
              onFinish={onFinish}
              scrollToFirstErrorDatePicker
              name="Validacion"
              initialValues={{
                estados_globales: ESTATUS_ACTIVO,
              }}
            >
              <Col xs={24} sm={24} md={24}>
                <Form.Item
                  name="concepto_incidencia"
                  label="Concepto de Incidencia"
                  rules={rules.required}
                  hasFeedback
                >
                  <Select
                    dataSource={incidencia.map((_incidencia) => ({ id: _incidencia?.id, descripcion: `${_incidencia?.clave}  ${_incidencia?.concepto}` }))}
                    disabled={disableFields}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={24}>
                <Form.Item
                  name="concepto_evaluacion"
                  label="Concepto de Evaluación"
                  rules={rules.required}
                  hasFeedback
                >
                  <Select
                    labelProp="nombre"
                    keyProp="id"
                    dataSource={evaluacionAsistencia}
                    disabled={disableFields}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={24}>
                <Form.Item
                  name="vigencia_final"
                  label="Vigencia Final"
                  hasFeedback
                >
                  <DatePicker
                    allowClear
                    format="YYYY-MM-DD"
                    disabled={isAdding || selectedData?.estados_globales?.id === ESTATUS_INACTIVO}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={24}>
                <Form.Item
                  name="estados_globales"
                  label="Estatus"
                  hasFeedback
                >
                  <Select
                    labelProp="descripcion"
                    keyProp="id"
                    dataSource={estados}
                    activeInactive={selectedData?.estados_globales?.id === ESTATUS_ACTIVO}
                    disabled={selectedRowKeys.length <= 0 || disableFields}
                    onChange={(val) => setVisibleConfirmInactivo(val === ESTATUS_INACTIVO)}
                  />
                </Form.Item>
              </Col>
              <Form.Item hidden>
                <Button htmlType="submit" />
              </Form.Item>
            </Form>
          </Modal>
          <ModalDelete
            onDelete={deleteItem}
            onCancel={() => setVisibleAlert(false)}
            open={visibleAlert}
            content={`Incidencia Validacion ${form.getFieldValue('concepto_de_evaluacion')?.nombre || ''}`}
            loading={loading}
          />
          <ModalConfirmation
            onFinish={onConfirmAutorizar}
            ConfirmAutorize
            onCancel={() => setVisibleAutorizar(false)}
            contentTitle={`Autorizar Incidencia Validacion ${form.getFieldValue('concepto_de_evaluacion')?.nombre || ''}`}
            open={visibleAutorizar}
            loading={loading}
          />
          <ModalConfirmation
            onFinish={() => setVisibleConfirmInactivo(false)}
            ConfirmInactive
            onCancel={() => {
              form.setFieldValue('estados_globales', ESTATUS_ACTIVO);
              setVisibleConfirmInactivo(false);
            }}
            open={visibleConfirmInactivo}
            contentTitle={`Inactivar Incidencia Validacion ${form.getFieldValue('concepto_de_evaluacion')?.nombre || ''}`}
            loading={loading}
          />
        </Spin>
      </Col>
    </Row>
  );
};

export default ValidacionesConfigReloj;
